import {Avatar, Card, Container, Grid, Typography} from "@mui/material";
import persianIcon from "../../icon/ic_persian.png";
import arabIcon from "../../icon/ic_arab.png";
import React from "react";
import {useTranslate} from "../../locales/use-locales";
import {useNavigate} from "react-router-dom";

export default function () {
    const {onChangeLang} = useTranslate()
    const navigate = useNavigate()
    return <Container>
        <Grid container spacing={2} py={2} alignItems={"stretch"}>
            <Grid item xs={12} md={6}>
                <Card onClick={() => {
                    onChangeLang("fa")
                    navigate("/")
                }} sx={{
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 1,
                    p: 2,
                    height: 1
                }}>
                    <Avatar src={persianIcon} variant={"square"} sx={{width: "auto", height: "200px"}}/>
                    <Typography mt={1} fontWeight={"bold"}>من فارسی زبان هستم و میخواهم عربی یاد بگیرم</Typography>
                    <Typography fontWeight={"lighter"}>أنا متحدث بالفارسية وأريد تعلم اللغة العربية</Typography>
                </Card>
            </Grid>
            <Grid item xs={12} md={6}>
                <Card onClick={() => {
                    onChangeLang("ar")
                    navigate("/")
                }} sx={{
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 1,
                    p: 2,
                    height: 1
                }}>
                    <Avatar src={arabIcon} variant={"square"} sx={{width: "auto", height: "200px"}}/>
                    <Typography mt={1} fontWeight={"bold"}>أنا متحدث بالعربية وأريد تعلم اللغة الفارسية</Typography>
                    <Typography fontWeight={"lighter"}>من عرب زبان هستم و میخواهم فارسی یاد بگیرم</Typography>
                </Card>
            </Grid>
        </Grid>
    </Container>
}